/* ==========================================================================
   GrandRanker Table of Contents Rebuilder — Tiger Fitness (Shopify Plus)
   ==========================================================================
   GrandRanker sends Shopify a plain "Table of Contents" heading followed by
   a nested <ul>/<li>/<a> list — no numbering, no card, no collapse behavior.
   This script rebuilds that into the numbered, collapsible card seen in the
   GrandRanker editor (01, 02, 03… rows, chevron toggle for rows that have
   sub-sections).

   Loaded only on the "grandranker" article template, same as the other
   GrandRanker scripts/styles.
   ========================================================================== */

(function () {
  "use strict";

  var CHEVRON_SVG =
    '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true">' +
    '<path d="M5 7l5 6 5-6" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildTOC(content) {
    var headings = content.querySelectorAll(":scope > h2");
    var tocHeading = null;

    headings.forEach(function (h) {
      if (!tocHeading && h.textContent.trim().toLowerCase() === "table of contents") {
        tocHeading = h;
      }
    });
    if (!tocHeading) return;

    var list = tocHeading.nextElementSibling;
    if (!list || list.tagName !== "UL") return;

    var card = document.createElement("div");
    card.className = "gr-toc";

    var header = document.createElement("div");
    header.className = "gr-toc__header";
    header.textContent = "Table of Contents";
    card.appendChild(header);

    var items = list.querySelectorAll(":scope > li");

    items.forEach(function (li, index) {
      var link = li.querySelector(":scope > a");
      if (!link) return;

      var subList = li.querySelector(":scope > ul");

      var row = document.createElement("div");
      row.className = "gr-toc__row";

      var num = document.createElement("span");
      num.className = "gr-toc__num";
      num.textContent = String(index + 1).padStart(2, "0");

      var titleLink = document.createElement("a");
      titleLink.className = "gr-toc__title";
      titleLink.href = link.getAttribute("href");
      titleLink.textContent = link.textContent;

      row.appendChild(num);
      row.appendChild(titleLink);

      if (subList) {
        var chevron = document.createElement("button");
        chevron.type = "button";
        chevron.className = "gr-toc__chevron";
        chevron.setAttribute("aria-expanded", "false");
        chevron.innerHTML = CHEVRON_SVG;
        row.appendChild(chevron);

        subList.className = "gr-toc__sublist";

        var toggle = function () {
          var isOpen = subList.classList.toggle("is-open");
          chevron.setAttribute("aria-expanded", isOpen ? "true" : "false");
        };

        chevron.addEventListener("click", toggle);
        row.addEventListener("click", function (e) {
          if (e.target === titleLink) return;
          toggle();
        });
      }

      card.appendChild(row);
      if (subList) card.appendChild(subList);
    });

    tocHeading.replaceWith(card);
    list.remove();
  }

  function init() {
    var content = document.querySelector(".article--content");
    if (content) buildTOC(content);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();